// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#expressPrintArea[data-v-13223627] {\n    width: 76mm;\n    height: 130mm;\n    /* margin-left: 100px; */\n    /*  float: left; */\n    /* background: url('../images/order/lttBackground.jpg') no-repeat; */\n    /* background-size: 104mm 175mm;\n    padding: 4mm 0.5mm 0.5mm 2.3mm; */\n}\n", ""]);
// Exports
module.exports = exports;
